import React from "react";
import { Modal, Row, Col } from "antd";

const RowForm = props => (
  <Row style={{ padding: " 5px 10px" }}>{props.children}</Row>
);

class ModalBranchAreaDetail extends React.Component {
  render() {
    const { data } = this.props;

    return (
      <Modal
        title="Branch Area Detail"
        visible={this.props.visible}
        onOk={() => this.props.visibleModal()}
        onCancel={() => this.props.visibleModal()}
        width={700}>
        <p>Branch Area Detail</p>

        <RowForm>
          <Col span={8}>Area Name</Col>
          <Col span={16}>: {data ? data.name : null}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Branch Internal</Col>
          <Col span={16}>: {data ? data.internalBranch : null}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Branch Code</Col>
          <Col span={16}>: {data ? data.codeBranch : null}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Boh Name</Col>
          <Col span={16}>
            :{" "}
            {data
              ? data.BOHProfile
                ? data.BOHProfile.User
                  ? data.BOHProfile.User.name
                  : ""
                : ""
              : null}
          </Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Pricing Area</Col>
          <Col span={16}>
            : {data ? (data.AreaPricing ? data.AreaPricing.name : null) : null}
          </Col>
        </RowForm>
      </Modal>
    );
  }
}

export default ModalBranchAreaDetail;



// WEBPACK FOOTER //
// src/components/Dashboard/Area/BranchArea/ModalBranchAreaDetail.js